import mark from '../assets/logo-mark.svg';

export function Footer() {
  return (
    <footer className="foot">
      <div className="foot__brand">
        <img src={mark} alt="" width={41} height={48} />
        <span>Synapse Fleet</span>
      </div>
      <p>
        The warehouse execution layer for mixed‑brand robot fleets.
        <br />
        Backed by Eurovet Logistics SRL · CUI 30943390.
      </p>
      <p className="foot__c">
        <a className="foot__mail" href="mailto:hub@synapsefleet.eu">hub@synapsefleet.eu</a>
        © 2026 Synapse Fleet
      </p>
    </footer>
  );
}
